import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationBloc } from '@kp/auth/authentication.bloc';
import { GroupValidationBloc } from '@kp/auth/group-validation.bloc';
import { UserBloc } from '@kp/user/user.bloc';
import { AuthDataService, DataStoreService, OnboardingUtilities, productDisplayName } from '@kservice';
import { UserType } from '@ktypes/enums';
import { Group, Status } from '@ktypes/models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { combineLatest, Subscription } from 'rxjs';

const ONBOARDING_PAGE = '/welcome/notice';

@Component({
  selector: 'kp-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss'],
})
export class ThankYouComponent implements OnInit, OnDestroy {
  @Input() currentUserType: UserType;
  @Input() groupCode: string;
  @Output() startedAction = new EventEmitter<void>();

  isMobile: boolean;
  productName = productDisplayName;
  transitionToOnboarding = false;
  userType = UserType;

  private subscriptions: Subscription[] = [];

  constructor(
    public authenticationBloc: AuthenticationBloc,
    private authDataService: AuthDataService,
    private dataStoreService: DataStoreService,
    public deviceService: DeviceDetectorService,
    private groupValidationBloc: GroupValidationBloc,
    private onboardingUtilities: OnboardingUtilities,
    private router: Router,
    private userBloc: UserBloc
  ) {}

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    this.subscriptions.push(
      combineLatest([this.dataStoreService.authStatus$, this.groupValidationBloc.groupValidationDataStatus$]).subscribe(
        ([authDataStatus, latestValidationStatus]) => {
          // wait for user to be created and group to be validated before moving on
          if (
            this.transitionToOnboarding &&
            authDataStatus &&
            authDataStatus?.status === Status.done &&
            authDataStatus?.data &&
            latestValidationStatus &&
            latestValidationStatus?.status === Status.done &&
            latestValidationStatus?.data
          ) {
            this.transitionToOnboarding = false;
            void this.router.navigate([ONBOARDING_PAGE]);
          }
        }
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription && subscription.unsubscribe());
  }

  continueOnboarding() {
    this.transitionToOnboarding = true;
    const authData = this.authDataService.loadToken();
    this.userBloc.createOnboardingUser(new Group().deserialize({ groupCode: this.groupCode }), authData.user?.id);
    this.groupValidationBloc.startValidatingGroupCode(this.groupCode, null, ONBOARDING_PAGE);
  }

  getStarted() {
    this.startedAction.emit();
  }
}
